<script>
	import {HOST,API,http_headers,SPINNER} from './global.js'
	import {USER,CLIENTE} from './store.js'
	import Cookie from 'js-cookie'
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();


	let user_info = {user:'',pass:''}
	let ds = {}
	let mensaje = ''
	let loading = false

	const login = async() => {
		loading = true
		let rs = await fetch(`${API}/login`,{
			method : 'POST',
			headers: http_headers,
	        body: JSON.stringify(user_info)
		})
		ds = await rs.json() || []
		loading = false
		if(ds.success){
			let vigencia = new Date(new Date().getTime() + 14 * 60 * 60 * 1000)
			Cookie.set(ds.token_cookie, ds.token_value, { expires:vigencia , path: HOST })
			Cookie.set(ds.user_cookie, JSON.stringify(ds.user_value), { expires:vigencia , path: HOST })
			let usr = Cookie.get('gsc-user') || '{"username":"", "fullname":"", "aclist":""}' 
			USER.set(JSON.parse(usr))
			dispatch("close", { page : 0 })
		}else{
			mensaje = ds.err
		}
	}

	const logout = () => {
		Cookie.remove("g3sc0m2", {path: '' })
		Cookie.remove("gsc-user2", {path: '' })
		Cookie.remove("g3sc0m", {path: '' })
		Cookie.remove("gsc-user", {path: '' })
		
		let usr = '{"username":"", "fullname":"", "aclist":""}' 
		CLIENTE.set('')
		USER.set(JSON.parse(usr))
		dispatch("close" , { page : 2 })
	}

</script>

<div class="container d-flex justify-content-center mt-4">
	{#if $USER.username===''}
		<form on:submit|preventDefault={login} on:reset|preventDefault={()=>dispatch("close", { page : 2 })} class="text-center">
			<p><img src="img/logo.png" alt="" width="70px"></p>
			<input class="my-2" bind:value = {user_info.user} placeholder="Usuario"><br>
			<input class="my-2" bind:value = {user_info.pass} placeholder="Clave" type=password>
			<br>
			<button class="btn btn-secondary my-2 " type=reset>Cancelar</button>
			<button class="btn btn-success my-2 " type=submit>
				Ingresar
			</button>
			
			{#if loading}
				<p class="text-success mt-4"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></p>
			{:else}
				<p class="text-danger mt-4">{mensaje}</p>
			{/if}
			
		</form>

	{:else}

		<form on:submit|preventDefault={logout} on:reset|preventDefault={()=>dispatch("close", { page : 0 })} class="text-center">
			<div class="alert alert-dark px-4" role="alert">
				Salir de la aplicacion?
				<br><br>
				<button class="btn btn-secondary my-2 " type=reset>No, Volver</button>
				<button class="btn btn-primary my-2 " type=submit>Si, Salir</button>
			</div>
		</form>

	{/if}

</div>

